<template>
  <a-modal
    destroyOnClose
    :footer="null"
    :maskClosable="false"
    centered
    title="批号检索"
    v-model="visible"
    width="70%">
    <template v-if="selectedRows.length > 0">
      <vxe-button icon="vxe-icon-square-close-fill" mode="text" size="mini" status="primary" @click="closeTag()"></vxe-button>
      <template v-for="row in selectedRows">
        <a-tooltip v-if="row.no.length > 10" :key="row.id" :title="row.no">
          <a-tag :key="row.id" :closable="true" @close="() => closeTag(row)" color="blue">
            {{ `${row.no.slice(0, 10)}...` }}
          </a-tag>
        </a-tooltip>
        <a-tag v-else :key="row.id" :closable="true" @close="() => closeTag(row)" color="blue">
          {{ row.no }}
        </a-tag>
      </template>
      <a-divider />
    </template>
    <a-space>
      <a-input-search
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.lotNo')"
        v-model="query.no"
      />
      <a-input-search
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.manufacturer')"
        v-model="query.manufacturer"
      />
      <a-input-search
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.producingArea')"
        v-model="query.producingArea"
      />
      <a-input-search
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.approvalNo')"
        v-model="query.approvalNo"
      />
      <vxe-button content="button.confirm" size="mini" status="primary" @click="confirm"/>
      <vxe-button content="button.cancel" size="mini" status="info" @click="cancel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true ,useKey:true, keyField: 'id'}"
      :column-config="{resizable: true}"
      :radio-config="{trigger: 'row'}"
      :checkbox-config="{trigger: 'row'}"
      style="margin-top: 2px"
      @checkbox-all="({checked})=>checkAll(checked)"
      @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="50" />
      <vxe-column field="no" title="business.label.lotNo" />
      <vxe-column field="manufacturer" title="business.label.manufacturer" />
      <vxe-column field="producingArea" title="business.label.producingArea" />
      <vxe-column field="approvalNo" title="business.label.approvalNo" width="150" />
      <vxe-column field="productionDate" title="business.label.productionDate" width="100" />
      <vxe-column field="validUntil" title="business.label.validUntil" width="100" />
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-modal>
</template>
<script>
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'LotModal',
    data() {
      return {
        size: 15,
        page: 1,
        contentSize: 0,
        visible: false,
        loading: false,
        data: [],
        query: { no: '', manufacturer: '', producingArea: '', approvalNo: '', 'item.id': null },
        args: null,
        record: undefined,
        selectedRows: [],
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.5)// 表格竖向滚动条
      }
    },
    props: {
      selectType: {
        type: String,
        default: 'radio'
      }
    },
    methods: {
      init(args) {
        this.query = { no: '', name: '', mnemonicCode: '' }
        this.data = []
        this.selectedRows = []
        this.page = 1
        if (args) {
          this.args = args
          Object.assign(this.query, args)
        }
      },
      open(args, e, selectedRows) {
        this.init(args)
        this.record = e
        if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
          this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
        }
        this.visible = true
        this.loading = true
        setTimeout(() => {
          this.getData()
        }, 300)
      },
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        if (this.query['item.id'] === null || this.query['item.id'] === undefined) {
          return this.$message.warning('请先选择商品')
        }
        this.loading = true
        findAll('lotFactory', this.query, this.page, this.size).then((res) => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
            if (this.selectedRows.length > 0) {
              this.$refs.table.setCheckboxRow(this.selectedRows, true)
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      search() {
        this.page = 1
        this.getData()
      },
      dblclick() {
        if (this.selectType === 'radio') {
          this.confirm()
        }
      },
      confirm() {
        let selectedRows
        if (this.selectType === 'radio') {
          let radioRow = this.$refs.table.getRadioRecord()
          if (radioRow !== null) {
            selectedRows = [radioRow]
          } else {
            selectedRows = []
          }
        } else {
          if (this.selectedRows.length > 0) {
            selectedRows = this.selectedRows
          } else {
            selectedRows = this.$refs.table.getCheckboxRecords()
          }
        }
        this.$emit('change', selectedRows, this.record)
        this.visible = false
      },
      cancel() {
        this.visible = false
      },
      closeTag(row) {
        if (row) {
          this.$refs.table.setCheckboxRow(row, false)
        } else {
          this.$refs.table.clearCheckboxRow()
        }
        this.removeSelectedRow(row)
      },
      addTag(row) {
        if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
          this.selectedRows.push(row)
        }
      },
      removeSelectedRow(row) {
        if (row) {
          this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
        } else {
          this.selectedRows = []
        }
      },
      changeCheckbox(checked, row) {
        if (this.selectType === 'radio') {
          return
        }
        if (checked) {
          this.addTag(row)
        } else {
          this.removeSelectedRow(row)
        }
      },
      checkAll(checked) {
        this.data.forEach(item => {
          if (checked) {
            this.addTag(item)
          } else {
            this.closeTag(item)
          }
        })
      }
    }
  }
</script>
